export class IAMUser {
    code: string;
    description: string;
    totalResults: string;
    resources: IAMUserResources[];
  }
  
  export class IAMUserResources{
    givenname: string;
    cn: string;
    sn: string;
    catloginid: string;
    active: boolean;
    mail: string;
    catbadgenumber: string;
  }

  export class SupplierSearch {
    code: string;
    description: string;
    totalResults: string;
    resources: SupplierResources[];
  }

  export class SupplierResources {
    catafltnclass: string;
    catafltnorgcode: string;
    catrecid: string;
    o: string;
    active: boolean;
    mail: string;
  }

  export class AddSupplier {
    id?: string;
    supplierName: string;
    organizationCode: string;
    division?: string;
    isActive: boolean;
    email?: string;
    isDeleted: boolean;
    comments?: string;
    hasFolderStructure: boolean;
    lN10?: string;
    lN55?: string;
    addedSupplyChainUsers?: AddedSupplyChainUsers[];
    removedSupplyChainUsers?: removedSupplyChainUsers[];
  }

  export class AddedSupplyChainUsers{
      id?: string;
      firstName?: string;
      lastName?: string;
      cwsId: string;
      cupidId?: string;
      email?: string;
      isActive?: boolean;
      roleName?: string;
      roleId?: number;
      isReadOnly?: boolean;
      isDeleted?: boolean;
      supplierID?: string;
      organization?: string;
      supplierCode?: string;
      supplierMap?: string;
  }

  export class removedSupplyChainUsers{
    id?: string;
    firstName?: string;
    lastName?: string;
    cwsId: string;
    cupidId?: string;
    email?: string;
    isActive?: boolean;
    roleName?: string;
    roleId?: number;
    isReadOnly?: boolean;
    isDeleted?: boolean;
    supplierID?: string;
    organization?: string;
    supplierCode?: string;
    supplierMap?: string;
}

export interface SupplierDetails {
  supplierName: string;
  organizationCode: string;
  division: string;
  isActive: boolean;
  email: string;
  isDeleted: boolean;
  comments: string;
  hasFolderStructure: boolean;
  id: string;
  createdUtc: Date;
  lastModifiedUtc: Date;
  createdBy: string;
  lastModifiedBy: string;
}

export class AddAditionalBuyers {
  currentAssigneeUserId: string;
  AddedAssignees: AddedAssignees[];
}

export class AddedAssignees {
  id: string;
  firstName: string;
  lastName: string;
  cwsId: string;
  cupidId: string;
  email: string;
  isActive: boolean;
  roleName: string;
  roleId: number;
  isReadOnly: boolean;
  isDeleted: boolean;
  supplierID: string;
  organization: string;
  supplierCode: string;
  supplierMap: supplierMap;
  suppliers: any;
}   

export class supplierMap {
  supplierBuyerMap: supplierBuyerMap;
}

export class supplierBuyerMap {
  supplierMap: string[];
}

export interface addSupplierChainUserDetails {
  id: string;
}

export interface removeSupplierChainUserDetails {
  id: string;
}

export class supplierDetails {
  division: string;
  id: string;
  isActive: string;
  lN10: string;
  lN55: string;
  organizationCode: string;
  supplierName: string;
}

export class supplierById {
  id: string;
  supplierName: string;
  organizationCode: string;
  division: string;
  isActive: string;
  lN10: string;
  lN55: string;
  addedSupplyChainUsers: addedSupplyChainUsers[];
  removedSupplyChainUsers: null;
}

export class addedSupplyChainUsers {
  id: string;
  firstName: string;
  lastName: string;
  cwsId: string;
}

export class sectionDetails {
  links: Links[];
  sectionDescription?: string;
  sectionHeader?: string;
  sectionOrder?: number;
  staticContentName?: string;
  startDate?: string;
  daysToShow?: number;
  type?: string;
  highImportance?: boolean;
  isUrgent?: boolean;
  isDeleted?: boolean;
  orderSequence?: number;
}

export class Links {
  linkAddress: string;
  linkTitle: string;
  linkType?: string;
  linksize?: number;
}


export class HomePageContents {
  sectionId?: string;
  sectionDetailJson: sectionDetails;
  comments?: string;
  isActive?: string | boolean;
}

export class CreateEditDialog {
  isEdit: boolean;
  activeCount?: number;
  data: HomePageContents;
}

export class CreateEditSolarDialog {
  isEdit: boolean;
  data: AddEditSolarForm;
}

export class AddEditSolarForm {
  formId?: string;
  formName: string;
  formNumber: string;
  description?: string;
  filePath?: string;
  file: File;
  extension?: string;
  isActive?: string | boolean;
  isDeleted?: boolean;
  createdBy?: string;
  lastModifiedBy?: null | string;
  createdUtc?: string;
  lastModifiedUtc?: string;
  category: string;
}

export class RtaAttachements {
  SupplierCode: string;
  SupplierName: string;
  RtaFile: File;
}

export class AdditionalSettingsFileExtension {
  maxFileSizeUpload: number;
}

// export class SectionDetailJson {
//   sectionHeader: string;
//   sectionDescription: string;
//   sectionOrder?: number;
//   links?: Links[];
// }
